<template>
  <div class="audit-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('auditParkingSpaceApply.page.title')" :subtitle="$t('auditParkingSpaceApply.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="goBack">
          {{ $t('auditParkingSpaceApply.back') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="doAudit">
          {{ $t('auditParkingSpaceApply.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 申请信息面板（只读信息网格） -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('auditParkingSpaceApply.applyInfo') }}</span>
      </div>

      <div class="ds-info-grid">
        <div class="ds-info-grid__item">
          <div class="ds-info-grid__label">{{ $t('auditParkingSpaceApply.licensePlate') }}</div>
          <div class="ds-info-grid__value ds-num">{{ formData.carNum || '-' }}</div>
        </div>
        <div class="ds-info-grid__item">
          <div class="ds-info-grid__label">{{ $t('auditParkingSpaceApply.carBrand') }}</div>
          <div class="ds-info-grid__value">{{ formData.carBrand || '-' }}</div>
        </div>
        <div class="ds-info-grid__item">
          <div class="ds-info-grid__label">{{ $t('auditParkingSpaceApply.carType') }}</div>
          <div class="ds-info-grid__value">{{ formData.carType || '-' }}</div>
        </div>
        <div class="ds-info-grid__item">
          <div class="ds-info-grid__label">{{ $t('auditParkingSpaceApply.color') }}</div>
          <div class="ds-info-grid__value">{{ formData.carColor || '-' }}</div>
        </div>
        <div class="ds-info-grid__item">
          <div class="ds-info-grid__label">{{ $t('auditParkingSpaceApply.startRentTime') }}</div>
          <div class="ds-info-grid__value ds-num">{{ formData.startTime || '-' }}</div>
        </div>
        <div class="ds-info-grid__item">
          <div class="ds-info-grid__label">{{ $t('auditParkingSpaceApply.endRentTime') }}</div>
          <div class="ds-info-grid__value ds-num">{{ formData.endTime || '-' }}</div>
        </div>
        <div class="ds-info-grid__item">
          <div class="ds-info-grid__label">{{ $t('auditParkingSpaceApply.applicant') }}</div>
          <div class="ds-info-grid__value">{{ formData.applyPersonName || '-' }}</div>
        </div>
        <div class="ds-info-grid__item">
          <div class="ds-info-grid__label">{{ $t('auditParkingSpaceApply.applicantPhone') }}</div>
          <div class="ds-info-grid__value ds-num">{{ formData.applyPersonLink || '-' }}</div>
        </div>
        <div class="ds-info-grid__item">
          <div class="ds-info-grid__label">{{ $t('auditParkingSpaceApply.applicantId') }}</div>
          <div class="ds-info-grid__value ds-num">{{ formData.applyPersonId || '-' }}</div>
        </div>
        <div class="ds-info-grid__item ds-info-grid__item--full">
          <div class="ds-info-grid__label">{{ $t('auditParkingSpaceApply.remark') }}</div>
          <div class="ds-info-grid__value">{{ formData.remark || '-' }}</div>
        </div>
      </div>
    </div>

    <!-- (3)(4) 审核表单面板 -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('auditParkingSpaceApply.auditInfo') }}</span>
      </div>

      <el-form ref="form" :model="formData" label-width="120px" class="ds-form">
        <el-form-item :label="$t('auditParkingSpaceApply.startRentTime')" required>
          <el-date-picker v-model="formData.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            :placeholder="$t('auditParkingSpaceApply.requiredField')" class="w-full" />
        </el-form-item>

        <el-form-item :label="$t('auditParkingSpaceApply.endRentTime')" required>
          <el-date-picker v-model="formData.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            :placeholder="$t('auditParkingSpaceApply.requiredField')" class="w-full" />
        </el-form-item>

        <el-form-item :label="$t('auditParkingSpaceApply.auditResult')" required>
          <el-select v-model="formData.state" :placeholder="$t('auditParkingSpaceApply.selectResult')"
            class="w-full">
            <el-option :label="$t('auditParkingSpaceApply.pass')" value="3003" />
            <el-option :label="$t('auditParkingSpaceApply.reject')" value="4004" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="formData.state === '3003'" :label="$t('auditParkingSpaceApply.selectParkingSpace')">
          <el-input v-model="formData.psName" :placeholder="$t('auditParkingSpaceApply.selectParkingSpace')" readonly
            class="w-full" />
          <el-button type="primary" icon="el-icon-search" class="ds-form-inline-btn" @click="openChooseParkingSpace">
            {{ $t('auditParkingSpaceApply.select') }}
          </el-button>
        </el-form-item>

        <el-form-item :label="$t('auditParkingSpaceApply.auditOpinion')">
          <el-input v-model="formData.remark2" type="textarea" :placeholder="$t('auditParkingSpaceApply.optional')"
            :rows="3" />
        </el-form-item>

        <div class="ds-form-actions">
          <el-button @click="goBack">
            {{ $t('auditParkingSpaceApply.back') }}
          </el-button>
          <el-button type="primary" @click="doAudit">
            {{ $t('auditParkingSpaceApply.submit') }}
          </el-button>
        </div>
      </el-form>
    </div>

    <!-- 搜索车位组件 -->
    <search-parking-space ref="searchParkingSpace" :ps-flag="formData.parkingSpaceFlag"
      @choose-parking-space="handleChooseParkingSpace" />
  </div>
</template>

<script>
import { getParkingSpaceApplyDetail, auditParkingSpaceApply } from '@/api/car/auditParkingSpaceApplyApi'
import SearchParkingSpace from '@/components/car/SearchParkingSpace'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'AuditParkingSpaceApply',
  components: {
    SearchParkingSpace,
    DsPageHeader
  },
  data() {
    return {
      formData: {
        applyId: '',
        communityId: getCommunityId(),
        psId: '',
        psName: '',
        carNum: '',
        carBrand: '',
        carType: '',
        carColor: '',
        startTime: '',
        endTime: '',
        applyPersonName: '',
        applyPersonLink: '',
        applyPersonId: '',
        state: '',
        remark: '',
        remark2: '',
        parkingSpaceFlag: 'F'
      }
    }
  },
  created() {
    this.formData.applyId = this.$route.query.applyId
    this.getApplyDetail()
  },
  methods: {
    async getApplyDetail() {
      try {
        const params = {
          page: 1,
          row: 1,
          applyId: this.formData.applyId
        }

        const res = await getParkingSpaceApplyDetail(params)
        if (res.data && res.data.length > 0) {
          Object.assign(this.formData, res.data[0])
          this.formData.state = ''
        }
      } catch (error) {
        this.$message.error(this.$t('common.queryFailed'))
      }
    },
    openChooseParkingSpace() {
      this.$refs.searchParkingSpace.open()
    },
    handleChooseParkingSpace(parkingSpace) {
      console.log('选择车位', parkingSpace)
      this.formData.psId = parkingSpace.psId
      this.formData.psName = parkingSpace.num
    },
    async doAudit() {
      // 验证逻辑
      if (!this.formData.state) {
        this.$message.warning(this.$t('auditParkingSpaceApply.selectResult'))
        return
      }

      if (this.formData.state === '3003' && !this.formData.psId) {
        this.$message.warning(this.$t('auditParkingSpaceApply.selectParkingSpace'))
        return
      }

      if (this.formData.state === '4004' && !this.formData.remark2) {
        this.$message.warning(this.$t('auditParkingSpaceApply.auditOpinionRequired'))
        return
      }

      try {
        // 合并备注信息
        const remark = `${this.formData.remark}\n审核意见：${this.formData.remark2}`

        const data = {
          ...this.formData,
          remark
        }

        await auditParkingSpaceApply(data)
        this.$message.success(this.$t('common.operationSuccess'))
        this.goBack()
      } catch (error) {
        this.$message.error(this.$t('common.submitFailed'))
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.audit-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &--padded {
    padding: var(--ds-spacing-lg);
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-lg);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

.ds-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: var(--ds-spacing-md) var(--ds-spacing-lg);

  &__item {
    min-width: 0;

    &--full {
      grid-column: 1 / -1;
    }
  }

  &__label {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-500);
    margin-bottom: 2px;
  }

  &__value {
    font-size: var(--ds-font-size-base);
    color: var(--ds-gray-900);
    word-break: break-all;
  }
}

.ds-form {
  .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }
}

.ds-form-inline-btn {
  margin-left: 10px;
}

.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding-top: var(--ds-spacing-md);
  border-top: 1px solid var(--ds-gray-200);
}
</style>
